import React from 'react';
import {t, Trans} from '@lingui/macro';

export const BillDuplicateReferenceInfo = {
    title: () => t`Warning`,
    onOk: (_, handleOk, action) => {
        const newAction = {...action};
        newAction.request.intercept_feedback = true;
        handleOk(newAction);
    },
    noPasscode: true,
    bodyStyle: { paddingBottom: 16 },
    okText: 'Save',
};

function BillDuplicateReference(props) {
    const { message } = props;
    return (
        <span>
            <p>
                {message}
            </p>
            <p>
                <Trans>Do you want to proceed?</Trans>
            </p>
        </span>
    );
}

export default BillDuplicateReference;
